import { errorStyle } from 'root/src/shared/constants/styles'
import withStyles from '@material-ui/core/styles/withStyles'

const styles = {
	error: errorStyle,
}

// eslint-disable-next-line import/prefer-default-export
export const FieldError = withStyles(styles, { name: 'FieldError' })(({ classes, error }) => (
	<span
		className={classes.error}
	>
		{error}
	</span>
))
